import React from 'react';
import PropTypes from 'prop-types';

const CommentSuggestion = props => (
  <div>
    <h3>{props.translations['some-tips']}</h3>
    <ol className="suggest-list">
      <li>{props.translations['comment-suggestion-1']}</li>
      <li>{props.translations['comment-suggestion-2']}</li>
      <li>{props.translations['comment-suggestion-3']}</li>
    </ol>
    <p>
      <strong>{props.translations['keep-it-brief']}</strong>
    </p>
    <button
      type="button"
      style={{ backgroundColor: props.color }}
      onClick={() => props.displayModal('')}
    >
      {props.translations.done}
    </button>
  </div>
);

CommentSuggestion.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  displayModal: PropTypes.func.isRequired,
};

export default CommentSuggestion;
